export const handleLogout = () => {
    localStorage.removeItem("accessToken");
    window.location.href = "/login"; // Redirect to login page
};
